
angular.module('cesium.graph.services', [
    // Services
    'cesium.graph.color.services',
    'cesium.graph.data.services'
  ])
;
